<template>
  <a :href="url" :target="target" :class="cssClass" :title="title">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    linkParts: function () {
      return this.link.split(' ')
    },
    url: function () {
      return this.linkParts.length ? this.linkParts[0] : ''
    },
    target: function () {
      return this.linkParts.length >= 2 ? this.linkParts[1] : ''
    },
    cssClass: function () {
      return this.linkParts.length >= 3 ? this.linkParts[2] : ''
    },
    title: function () {
      return this.linkParts.length >= 4 ? this.linkParts[3] : ''
    }
  }
}
</script>
